import type { FC } from 'react';
import { AnimatedRotate, Icon, Text } from '@cencosud-cencommerce/paris-uikit';

interface ToggleProductsProps {
  isOpen: boolean;
  toggleOpen: () => void;
}
const ToggleProducts: FC<ToggleProductsProps> = ({ isOpen, toggleOpen }) => {
  return (
    <div
      className="co-flex co-self-center co-items-center co-gap-2"
      onClick={toggleOpen}
    >
      <div className="co-flex co-text-end">
        <Text variant="link1" color="primary-500" weight={600}>
          {isOpen ? 'Ocultar productos' : 'Mostrar productos'}
        </Text>
      </div>
      <AnimatedRotate isRotated={isOpen}>
        <Icon name="arrow-down" fill="primary-500" />
      </AnimatedRotate>
    </div>
  );
};

export default ToggleProducts;
